import { ExternalUser, SalesPerson } from "models/customers/customers";

export type DocumentService = {
  id: string;
  customerChoice: string | boolean;
  userIds: string[];
  enabled?: boolean;
};

export type WizardCustomer = {
  id: string;
  isPrivate: boolean;
  sniCode: string;
  customerName: string;
  organizationNumber: string;
  state: string;
  fpConfig?: any;
  fpService?: any;
  isEditing?: boolean;
  disableFp?: boolean;
  reactivation?: boolean;
  contactInformation: {
    address1: string;
    address2: string;
    zipCode: string;
    city: string;
    country: string;
    countryCode: string;
    phone: string;
    mobilePhone: string;
    faxNumber: string;
    email: string;
  };
  services: DocumentService[];
  customerServices: DocumentService[];
  internalUsers: SalesPerson[];
  externalUsers: ExternalUser[];
  servicesLockedByNavigation?: boolean;
  activeProjectTypes: string[];
  documentServices: DocumentService[];
  validUserData?: any;
  entraTenantId?: string;
};

export type WizardState = {
  showWarningFp: boolean;
  isSaving: boolean;
  isLoading: boolean;
  customer: WizardCustomer;
  hasErrors: boolean;
};

export const initialWizardCustomerState = {
  id: "", //CustomerNumber in api
  isPrivate: false,
  sniCode: "",
  customerName: "",
  reactivation: false,
  organizationNumber: "",
  state: "",
  contactInformation: {
    address1: "",
    address2: "",
    zipCode: "",
    city: "",
    country: "",
    countryCode: "",
    phone: "",
    mobilePhone: "",
    faxNumber: "",
    email: ""
  },
  services: [],
  customerServices: [],
  internalUsers: [],
  externalUsers: [],
  servicesLockedByNavigation: false,
  activeProjectTypes: [],
  documentServices: [],
};

export const initialWizardState: WizardState = {
  showWarningFp: false,
  isSaving: false,
  isLoading: false,
  customer: initialWizardCustomerState,
  hasErrors: false
};
